export enum QueryKeys {
  Banners = 'Banners'
}

export type Templates = 'ProductBanner' | 'MessageBanner' | 'PromoBanner' | 'ImageBanner';

export interface Banner {
  locale: string;
  campaign?: string;
  template: string;
  dates?: BannerDate[];
  startDate?: string;
  endDate?: string;
  content: any;
  isErrored?: boolean;
}

export interface Image {
  alt: string;
  type: string;
  url: string;
}

export interface Script {
  text: string;
  size: string | null;
}

export interface BannermaticData {
  HomePage: Banner[];
}

export interface BannerDate {
  startDate: string;
  endDate: string;
}